import { json } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import { ApiService } from '../../../utils/api-service';

@autoinject
export class CostCenterService {
	constructor(private api: ApiService) {
	}

	addCostCenter(organizationalUnitId: string, costCenter: ICostCenterAM): Promise<Response> {
		return this.api.fetch(`cost-centers/${organizationalUnitId}/add`, {
			method: 'post',
			body: json(costCenter)
		});
	}

	updateCostCenter(costCenter: ICostCenterAM): Promise<Response> {
		return this.api.fetch(`cost-centers/update`, {
			method: 'post',
			body: json(costCenter)
		});
	}

	removeCostCenter(costCenter: ICostCenterAM): Promise<Response> {
		return this.api.fetch(`cost-centers/remove/${costCenter.id}`, {
			method: 'post'
		});
	}

	hasDependencies(costCenterId: string): Promise<boolean> {
		return this.api.fetchJson(`cost-centers/${costCenterId}/dependencies/any`);
	}
}

export interface ICostCenterAM {
	id?: string;
	identifier: string;
	name: string;
	activeFrom: Date;
	activeUntil: Date;
}

export class CostCenter {
	id: string;
	identifier: string;
	name: string;
	removable: boolean = false;
	activeFrom: Date;
	activeUntil: Date;

	constructor(init: Partial<CostCenter>) {
		Object.assign(this, init);
	}

	toAM(): ICostCenterAM {
		return {
			id: this.id,
			identifier: this.identifier,
			name: this.name,
			activeFrom: this.activeFrom,
			activeUntil: this.activeUntil
		};
	}
}
